import React from 'react';
import { services } from '../../globals/app';
import styles from './YoutubeModal.module.scss';
import Modal from '@material-ui/core/Modal';
import YouTube from 'react-youtube';
import YOUTUBE from '../../constants/youtube';
import { AxiosResponse } from 'axios';
import { useStore } from 'contexts/store';
import { VideosMoviesResponse } from '../../types/api';

const YoutubeModal: React.FC = ({
  modal, 
  setModal
} : {
  modal:boolean, 
  setModal: () => void
}) : JSX.Element => {

   let { state } = useStore();
	 let [trailer, setTrailer] = React.useState([]);

	 React.useEffect(() => {
       if( state.trailer === 'story') {
          services.serie.getVideosForSeries(state.serie.id)
           .then((videos:AxiosResponse<VideosMoviesResponse>) => handleVideo(videos.data.results[0].key))   
       } else {
          services.movie.getVideosForMovie(state.movie.id)
           .then((videos:AxiosResponse<VideosMoviesResponse>) => handleVideo(videos.data.results[0].key))   
       }
	 },[modal]);


	const handleVideo = (id: any) : void => {
     setTrailer(id);
     setModal(true);
   };

   const ModalContent  = () => {
     return (
    <div className={styles.modal}>
       <YouTube videoId={trailer} opts={YOUTUBE} />
    </div>
    )
   };

   return (
    <Modal
      open={modal}
      onClose={() => setModal(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={styles.modal}
	   >
		 <ModalContent />
	</Modal>
    );
};

export default YoutubeModal; 